// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"a20ea947","278":"1a700d99","617":"b2a9c80b","745":"27b1b52e","820":"1fe0d378","895":"1e5d28a4"}[chunkId] + ".chunk.js";
};